import { MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';

const INTERACTIVE_SELECTOR = 'a, button, input, select, textarea';

export default function useRowNavigation(
  path: string,
  getNavigationState?: () => unknown
) {
  const navigate = useNavigate();

  return (event: MouseEvent<HTMLElement>) => {
    const isInteractiveTarget =
      event.target instanceof Element &&
      !!event.target.closest(INTERACTIVE_SELECTOR);

    if (isInteractiveTarget || window.getSelection()?.toString()) {
      return;
    }

    navigate(path, { state: getNavigationState?.() });
  };
}
